<mat-progress-bar class="progress-bar" mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
<div class="container" fxLayout="row wrap">
    <div fxFlex="100">
        <div fxLayout="row wrap" class="p-l-5">
            <div fxFlex="100">
                <img [src]="practiceLogoUrl" height="45">
            </div>
        </div>
        <div fxLayout="row wrap" *ngIf="this.drawingDetails.id" fxLayout.xs="column-reverse" fxLayout.sm="column-reverse" class="section1-container" fxLayoutAlign="space-between start">
            <div class="p-l-r-5" fxLayout="column" fxFlex.gt-sm="45" fxFlex="100" fxLayoutAlign="space-between start">
                <h1 fxLayout="row" class="text-black">{{drawingDetails.title}}</h1>
                <h4 fxLayout="row" class="text-black desc">{{drawingDetails.detailedDescription}}</h4>
            </div>
            <div class="p-l-5" fxFlex.gt-sm="55" fxFlex="100">
                <img [src]="drawingDetails.heroImageURL" class="drawing-img">
            </div>
        </div>
    </div>
    <mat-card *ngIf="winners.length" class="winner-container" fxLayout="row wrap" fxFlex="100" fxLayoutAlign="center center">
        <mat-card-content fxFlex.gt-sm="60" fxFlex="100">
            <div fxLayout="row wrap" fxLayoutAlign="center center">
                <h1>Winners</h1>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center">
                <h3>{{drawingDetails.title}} &nbsp;</h3>
                <h3 class="m-0"> ( {{drawingDetails.runDate | date}} )</h3>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center">
                <div>
                    <h5>{{getWinnerTitle(drawingDetails)}}</h5>
                    <div fxLayout="row wrap" fxLayoutAlign="center center">
                        <div fxFlex.gt-sm="40" fxFlex.gt-md="38" fxFlex.lt-md="38" fxFlex.lt-sm="57" fxFlex="70" *ngFor="let result of winners" class="winner-ticket-container">
                            <div fxLayout="row wrap" fxLayoutAlign="center center">
                                <span>{{result.ticketNo}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="drawingDetails.runStatus==='Executed'" class="winner-container" fxLayout="row wrap" fxFlex="100" fxLayoutAlign="center center">
      <mat-card-content>
          <h1>We will update the results soon</h1>
      </mat-card-content>
    </mat-card>
    <!-- <div class="section4-container" fxFlex="100">
        <div fxLayout="row wrap" fxFlex="100" class="rules-container">
            <div fxLayout="row wrap" fxLayoutAlign="center start" fxFlex="100">
                <h2 class="text-white">Upcoming drawings</h2>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center start" fxFlex="100">
                <mat-card fxFlex.gt-sm="22" fxFlex="100" class="rule-card">
                    <mat-card-content fxLayout="row wrap" fxLayoutAlign="center start">
                        <img mat-card-image src="../../assets/images/landing-page/rule1.png" class="rule-logo">
                        <p class="rule-desc" class="rule-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore</p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div> -->
    <div fxLayout="row wrap" class="section5-container p-l-r-5" fxFlex="100">
        <div fxFlex.gt-md="20" fxFlex.gt-xs="33" fxFlex="100" class="footer-logo">
            <img [src]="practiceLogoUrl" height="45">
        </div>
        <div class="text-black" fxFlex.gt-md="30" fxFlex.gt-xs="28" fxFlex="100">
            <h3>Contact us</h3>
            hello@carecognitics.com <br/>
            <a>+650.617.3425</a>
        </div>
        <div class="text-black" fxFlex.gt-md="40" fxFlex.gt-xs="38" fxFlex="100">
            <h3>Disclaimer</h3>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </div>
    </div>
</div>